/*
 * File: aws-exports.js
 * Project: a-a
 * File Created: Wednesday, 6th August 2025 12:47:28 am
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 6th August 2025 12:49:20 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const config = {
  API: {
    GraphQL: {
      endpoint: 'https://l4cjeno4ajaqhba6x2jjvngody.appsync-api.us-east-1.amazonaws.com/graphql',
      region: 'us-east-1',
      defaultAuthMode: 'apiKey',
      apiKey: 'da2-zvfvsonymvehvd5453vfbnjdti',
    },
  },
};

export default config;
